import React from 'react';
import Dashboard from './Dashboard';

const DashboardPage: React.FC = () => {
  return (
    <div className="dashboard-page">
      <Dashboard />
    </div>
  );
};

export default DashboardPage;